import {PitchLimit, PitchResult, SimulationData} from "../../simulationTypes";
import {pitchAble_1, pitchAble_2, pitchLimits, sPitchAble_1, total} from "../../simulationFunctions";
import {RuleType} from "../../RuleType";

// 数値変化イベント時にリストから対象データを更新する：1試合目用
export const modifySimGame1 = (simulation:SimulationData, simulations:SimulationData[], value:string, rule: RuleType): SimulationData[] => {
  const limit = pitchLimits(rule);
  const isYoungRule = (rule === RuleType.junior || rule === RuleType.young);
  return simulations.map((simulationData) => {
    //該当するデータの更新
    if(simulationData.id === simulation.id){
      simulationData.today.pitch_1 = Number(value? value : 0);
      if(simulationData.today.pitch_1 >= limit.oneDay) simulationData.today.pitch_2 = 0;
      // ヤング・ジュニアとリトルで当日の上限を分岐
      simulationData.oneDayAfter.limit = isYoungRule ? pitchAble_1(simulationData.today, rule) : sPitchAble_1(simulationData.today);
      // ジュニアリーグのみの特別処理
      if(rule === RuleType.junior) simulationData.today.limit = juniorDoubleHeaderLimit(simulation, 0);
      if(isYoungRule && !pitchAble_1(simulationData.today, rule)){ // ヤングリーグのみ：初日連投で翌日登板不可状態になったケース
        simulationData.oneDayAfter.pitch_1 = 0;
        simulationData.oneDayAfter.pitch_2 = 0;
        simulationData.twoDaysAfter.limit = limit.oneDay;
        simulationData.threeDaysAfter.limit = pitchAble_2(simulationData.oneDayAfter, simulationData.twoDaysAfter, rule);
      } else {
        simulationData.twoDaysAfter.limit = pitchAble_2(simulationData.today, simulationData.oneDayAfter, rule);
        simulationData.threeDaysAfter.limit = pitchAble_2(simulationData.oneDayAfter, simulationData.twoDaysAfter, rule);
      }
      return simulationData;
    }
    //非該当時
    return simulationData;
  });
}

// 数値変化イベント時にリストから対象データを更新する：2試合目用
export const modifySimGame2 = (simulation:SimulationData, simulations:SimulationData[], value:string, rule:RuleType): SimulationData[] => {
  // const limit = pitchLimits(rule);
  const isYoungRule = (rule === RuleType.junior || rule === RuleType.young);
  return simulations.map((simulationData) => {
    //該当するデータの更新
    if(simulationData.id === simulation.id){
      simulationData.today.pitch_2 = Number(value? value : 0);
      // ジュニアリーグのみの特別処理
      if(rule === RuleType.junior) simulationData.today.limit = juniorDoubleHeaderLimit(simulation, 0);
      if(simulationData.today.pitch_2 >= simulationData.today.limit) simulationData.today.pitch_1 = 0;
      if(isYoungRule && !pitchAble_1(simulationData.today, rule)){ // ヤングリーグのみ：初日連投で翌日登板不可状態になったケース
        simulationData.oneDayAfter.pitch_1 = 0;
        simulationData.oneDayAfter.pitch_2 = 0;
      }
      simulationData.oneDayAfter.limit = isYoungRule ? pitchAble_1(simulationData.today, rule) : sPitchAble_1(simulationData.today);
      return simulationData;
    }
    //非該当時
    return simulationData;
  });
}

const juniorDoubleHeaderLimit = (simulation: SimulationData, targetNum: number): number => {
  const limit = pitchLimits(RuleType.junior);
  //ダブルヘッダーの登板かチェック
  if (isDoubleHeaderPitch(simulation,targetNum)) {
    //前日登板がなければ70球制限に変更
    if (!isBeforeDayPitched(simulation, targetNum)) return 70;
    //前日に2連投してたら4連投目データは来ないため、自ずと前日は1登板となるのでその条件で処理
    return juniorPitchLimit(simulation, targetNum, limit);
  }
  return limit.oneDay;
}

const isDoubleHeaderPitch = (simulation: SimulationData, targetNum: number): boolean => {
  if (targetNum === 0) return (!!simulation.today.pitch_1 && !!simulation.today.pitch_2);
  if (targetNum === 1) return (!!simulation.oneDayAfter.pitch_1 && !!simulation.oneDayAfter.pitch_2)
  if (targetNum === 2) return (!!simulation.twoDaysAfter.pitch_1 && !!simulation.twoDaysAfter.pitch_2)
  if (targetNum === 3) return (!!simulation.threeDaysAfter.pitch_1 && !!simulation.threeDaysAfter.pitch_2)
  return false;
}

const isBeforeDayPitched = (simulation: SimulationData, targetNum: number): boolean => {
  if (targetNum === 1) return (!!simulation.today.pitch_1 || !!simulation.today.pitch_2);
  if (targetNum === 2) return (!!simulation.oneDayAfter.pitch_1 || !!simulation.oneDayAfter.pitch_2)
  if (targetNum === 3) return (!!simulation.twoDaysAfter.pitch_1 || !!simulation.twoDaysAfter.pitch_2)
  return false;
}

const juniorPitchLimit = (simulation: SimulationData, targetNum: number, limit: PitchLimit) :number => {
  if (targetNum === 1) return limit.twoDays - total(simulation.today) >= 70 ? 70 : limit.twoDays - total(simulation.today);
  if (targetNum === 2) return limit.twoDays - total(simulation.oneDayAfter) >= 70 ? 70 : limit.twoDays - total(simulation.oneDayAfter);
  if (targetNum === 3) return limit.twoDays - total(simulation.twoDaysAfter) >= 70 ? 70 : limit.twoDays - total(simulation.twoDaysAfter);
  return 9999; //エラー用
}

// 翌日の投球制限数を更新する
export const modifySimInAnotherGameTsx = (simulationData: SimulationData, value:string, rule:RuleType, simulation: SimulationData, targetDay: number, gameNum: 1|2): SimulationData => {
  if(gameNum === 1) {
    if (targetDay === 1) {
      simulationData.oneDayAfter.pitch_1 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.oneDayAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
      simulationData.twoDaysAfter.limit = pitchAble_2(simulationData.today, simulationData.oneDayAfter, rule);
    } else if (targetDay === 2) {
      simulationData.twoDaysAfter.pitch_1 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.twoDaysAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
      simulationData.threeDaysAfter.limit = pitchAble_2(simulationData.oneDayAfter, simulationData.twoDaysAfter, rule);
    } else {
      simulationData.threeDaysAfter.pitch_1 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.threeDaysAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
    }
  } else {
    if (targetDay === 1) {
      simulationData.oneDayAfter.pitch_2 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.oneDayAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
      simulationData.twoDaysAfter.limit = pitchAble_2(simulationData.today, simulationData.oneDayAfter, rule);
    } else if (targetDay === 2) {
      simulationData.twoDaysAfter.pitch_2 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.twoDaysAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
      simulationData.threeDaysAfter.limit = pitchAble_2(simulationData.oneDayAfter, simulationData.twoDaysAfter, rule);
    } else {
      simulationData.threeDaysAfter.pitch_2 = Number(value? value : 0);
      if(rule === RuleType.junior) simulationData.threeDaysAfter.limit = juniorDoubleHeaderLimit(simulation, targetDay);
    }
  }
  return simulationData
}

export const rest = (simulation: SimulationData, pitchResult: PitchResult, targetDay: number, limit: PitchLimit, rule: RuleType): number => {
  if (isDoubleHeaderPitch(simulation, targetDay) && rule !== RuleType.littleSenior) {
    if (isBeforeDayPitched(simulation, targetDay)) {
      const restAtTwoGame = pitchResult.limit - pitchResult.pitch_1 >= limit.threeGames ? limit.threeGames : pitchResult.limit - pitchResult.pitch_1;
      return restAtTwoGame - pitchResult.pitch_2;
    }
  }
  return pitchResult.limit - pitchResult.pitch_1 - pitchResult.pitch_2;
}
